const philosophyItems = [
  {
    icon: 'ri-lightbulb-line',
    title: 'Innovation-Driven',
    desc: 'We actively explore new technologies and methodologies, integrating the most promising advances into our workflow to deliver modern, forward-looking solutions.',
  },
  {
    icon: 'ri-loop-right-line',
    title: 'Process Evolution',
    desc: 'Internal workflows are continuously evaluated and refined. We treat our own development practices with the same rigor we apply to the software we build.',
  },
  {
    icon: 'ri-award-line',
    title: 'Engineering Standards',
    desc: 'Up-to-date engineering standards guide every decision. From code conventions to architectural patterns, consistency and quality are non-negotiable.',
  },
  {
    icon: 'ri-rocket-line',
    title: 'Future-Ready Systems',
    desc: 'Every system is designed with longevity in mind, using practices and technologies that ensure adaptability and resilience in an ever-changing landscape.',
  },
];

export default function PhilosophySection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-6 md:px-10 bg-background-100 overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-primary-100/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative z-10 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="w-10 h-px bg-accent-500/60 mb-6"></div>
            <p className="text-sm tracking-widest uppercase text-foreground-500 font-label mb-6">
              Our Philosophy
            </p>
            <h2 className="text-3xl md:text-4xl font-heading font-light text-foreground-900 leading-tight mb-10">
              Continuous Innovation &amp; Technical Excellence
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed font-light">
              Technology moves fast, and we move with it. The team actively explores
              emerging technologies and continuously refines its internal processes
              to stay at the forefront of modern software engineering. This
              commitment to evolution ensures that every solution we deliver is not
              just current, but genuinely future-ready.
            </p>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <div className="space-y-8">
              {philosophyItems.map((item) => (
                <div key={item.title} className="flex gap-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100/70 shrink-0 mt-0.5">
                    <i className={`${item.icon} text-accent-600 text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-heading font-medium text-foreground-900 mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed font-light">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}